import { Spinner } from "@sg/ui";
import { useEffect } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { StringParam, useQueryParam } from "use-query-params";
import { useCounterparties } from "~/hooks/query";
import { ROUTE } from "~/routes/config";
import useAuthStore from "~/store/auth";
import useSettingPrefStore from "~/store/setttingPref";
import useTradeStore from "~/store/trade";

export function TradeSharePage({ isPackage, isForward }: { isPackage?: boolean; isForward?: boolean }) {
  const entity = useSettingPrefStore((state) => state.entity);
  const setParameters = useTradeStore((state) => state.setParameters);
  const { org_id } = useAuthStore((state) => state.userInfo);
  const { data, dataUpdatedAt } = useCounterparties();
  const navigate = useNavigate();
  const [parameters] = useQueryParam("parameters", StringParam);

  useEffect(() => {
    const cpId = entity || data?.[0]?.id;
    if (org_id && cpId) {
      let currRoute;

      if (isPackage) {
        currRoute = ROUTE.SPREADS;
      } else if (isForward) {
        currRoute = ROUTE.FORWARDS;
      } else {
        currRoute = ROUTE.OPTIONS;
      }

      navigate(
        generatePath(currRoute, {
          orgId: org_id,
          cpId: cpId,
        })
      );
      setParameters(parameters || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdatedAt, entity, org_id]);

  return (
    <div className="flex items-center justify-center p-16">
      <Spinner />
    </div>
  );
}
